module.exports = __webpack_public_path__ + "static/media/projectsImage.b8ba9487.svg";